import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CustomAccordion, CustomSwitch } from '../../../../shared/uiComponents';
import { Tab, TabsContainer } from '../../../../shared/uiComponents/Tabs';
import Text from '../../../../shared/uiComponents/Text';
import { MaintenanceHeader } from '../SkillAcquisition/SkillAreas/Components/SkillAccordionHeader';
import { MaintenanceContent } from '../SkillAcquisition/SkillAreas/Components/SkillAccordionContent';
import { useScreenWidth } from '../../../../shared/Helpers/hooks';

import API from '../../../../redux/API/Main/API';
import { ClientFunderProperties } from '../../../../redux/API/ClientAPIHelpers/funding';
import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getSkillAreas } from '../../../../redux/State/clientSlice/skillAreaSlice';
import { ELC_FUNDER_ID } from '../../../../redux/API/constants';

const ELC_FUNDER_NAME = 'ELC';

const MasteredTargets = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const skillAreas = useSelector((state) => state.skillArea.skillAreas);
	const [includeArchived, setIncludeArchived] = useState<boolean>(false);

	// Funder tabs: null = Insurance + DOE (shared tree); elcFunderId = ELC (separate tree).
	const [elcFunderId, setElcFunderId] = useState<string | null>(null);
	const [activeFunderId, setActiveFunderId] = useState<string | null>(null);

	useEffect(() => {
		if (!clientId) return undefined;

		let cancelled = false;

		API.ClientAPI.Funding.getClientFunders(clientId).then((response) => {
			if (cancelled || response?.error) return;
			const funders = response as ClientFunderProperties[];
			const elc = funders?.find((f) => f.funderName === ELC_FUNDER_NAME);
			setElcFunderId(elc?.funderId ?? null);
		});

		return () => {
			cancelled = true;
		};
	}, [clientId]);

	useEffect(() => {
		if (!clientId) return;
		dispatch(getSkillAreas({ clientId, includeArchived, funderId: activeFunderId }));
	}, [clientId, includeArchived, activeFunderId, dispatch]);

	const showArchivedSkillAreasHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeArchived(checked);
	};

	const selectFunderTab = (funderId: string | null) => {
		if (funderId === activeFunderId) return;

		setActiveFunderId(funderId);
	};

	return (
		<>
			{elcFunderId && (
				<div style={{ padding: '16px 24px 0' }}>
					<TabsContainer>
						<Tab selected={activeFunderId === null} onClick={() => selectFunderTab(null)} style={{ cursor: 'pointer' }}>
							<Text
								title="Insurance + DOE"
								type="psm"
								fontWeight={activeFunderId === null ? 'semiBold' : 'medium'}
							/>
						</Tab>
						<Tab
							selected={activeFunderId === elcFunderId}
							onClick={() => selectFunderTab(elcFunderId)}
							style={{ cursor: 'pointer' }}
						>
							<Text title="ELC" type="psm" fontWeight={activeFunderId === elcFunderId ? 'semiBold' : 'medium'} />
						</Tab>
					</TabsContainer>
				</div>
			)}
			<div className="maintenanceHeader">
				<CustomSwitch
					label="Show Archived"
					checked={includeArchived}
					onChange={showArchivedSkillAreasHandler}
					backgroundType="base"
					fullWidth={isMobile}
				/>
			</div>
			<div className="maintenanceContainer">
				{skillAreas?.map((item) => (
					<div className="maintenanceAccordion" key={item.id}>
						<CustomAccordion
							HeaderContent={() => <MaintenanceHeader item={item} isElc={activeFunderId?.toLowerCase() === ELC_FUNDER_ID} />}
							Content={() => <MaintenanceContent item={item} />}
							defaultExpanded={false}
							accordionClassName="clientInfoAccordion"
							accordionDetailsClassName="maintenanceAccordionDetails"
						/>
					</div>
				))}
			</div>
		</>
	);
};

export default MasteredTargets;
